import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import fuzzy from 'fuzzy';
import moment from 'moment-timezone';

// Components
import Autosuggest from '@sift/skipper/components/Autosuggest';
import withPopper from '@sift/skipper/components/Autosuggest/withPopper';
import Typography from '@material-ui/core/Typography';

// Style
import withStyles from '@material-ui/core/styles/withStyles';

const AutoPopper = withPopper(Autosuggest);

const styles = theme => {
  return {
    root: {
      marginTop: theme.spacing(2),
    },
    input: {
      minWidth: 300,
    },
    header: {},
    subheader: {},
  };
};

class CompanyTimezone extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    classes: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      suggestions: moment.tz.names().slice(0, 8),
      inputValue: props.value,
    };
  }

  timeZoneNames = moment.tz.names();
  timeZoneByName = moment.tz.names().reduce((timeZoneDictionary, timeZone) => {
    return {
      ...timeZoneDictionary,
      [timeZone]: true,
    };
  }, {});

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.value !== this.props.value) {
      this.setState({ inputValue: this.props.value });
    }
  }

  handleSelect = (e, { suggestionValue }) => {
    const { onChange } = this.props;
    onChange('client.settings.info.timeZone', suggestionValue);
    this.setState({
      suggestions: moment.tz.names().slice(0, 8),
      inputValue: suggestionValue,
    });
  };

  handleChange = e => {
    const value = e.target.value;
    this.setState({
      inputValue: value,
    });
  };

  handleBlur = () => {
    this.setState({
      inputValue: this.props.value,
    });
  };

  recalculateSuggestions = ({ value }) => {
    this.setState({
      suggestions: fuzzy
        .filter(value, moment.tz.names())
        .slice(0, 8)
        .map(match => match.string),
    });
  };

  runValidation(value) {
    if (!this.timeZoneByName[value]) {
      return 'Select a timezone from the list.';
    }

    return undefined;
  }

  render() {
    const { classes } = this.props;
    const { inputValue } = this.state;

    return (
      <div className={classes.root}>
        <Typography variant="h6">Time Zone</Typography>
        <Typography variant="subtitle2">
          Select the default time zone to be used by Sift for external communications to users. This
          should usually be set to the time zone that most of your users are in.
        </Typography>
        <AutoPopper
          inputProps={{
            'aria-label': 'time zone',
            className: classes.input,
            label: 'Time Zone',
            value: inputValue,
            onChange: this.handleChange,
            onBlur: this.handleBlur,
          }}
          suggestions={this.state.suggestions}
          onSuggestionSelected={this.handleSelect}
          onSuggestionsFetchRequested={this.recalculateSuggestions}
        />
      </div>
    );
  }
}

export default withStyles(styles)(CompanyTimezone);
